// 手机号验证
function isvalidPhone(str) {
  const reg = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
  return reg.test(str);
}

function validTax(tax) {
  let reg = /^\d{15}$/
  return reg.test(tax)
}

/*********************************** 表单验证 ***********************************/
// 手机号验证
function validPhone(rule, value, callback) {
  if (!value) {
    callback(new Error("请输入手机号码"));
  } else if (!isvalidPhone(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};

// 统一社会信用代码
function validUscc(rule, value, callback) {
  console.log(validTax(value))
  if (!value) {
    callback(new Error("请填写统一社会信用代码"));
  } else if (value.length !== 18 && !validTax(value)) {
    callback(new Error("统一社会信用代码长度错误！"));
  } else {
    callback();
  }
}

let checkProvAndCity = (rule, value, callback) => {
  console.log(this.$refs.city.value)
  if (!value) {
    callback(new Error('省份必填'))
  } else if (!this.$refs.city.value) {
    callback(new Error('市级必填'))
  } else {
    callback()
  }
}



export {
  validPhone,
  validUscc,
  checkProvAndCity
}